export function extractDataFromResponse(response) {
    if (response.status === 204) {
        return undefined
    }
    return response.data
}